module.exports = require("@agm/core/services/managers/polygon-manager");